import { render } from "./CallCenterNew.vue?vue&type=template&id=44cc4611&scoped=true"
import script from "./CallCenterNew.vue?vue&type=script&lang=js"
export * from "./CallCenterNew.vue?vue&type=script&lang=js"

import "./CallCenterNew.vue?vue&type=style&index=0&id=44cc4611&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44cc4611"]])

export default __exports__